import multiRequest from '../shared/multiRequest';

const getFeatureFlag = feat => {
  return multiRequest([
    {
      url: `customer/feature-flags/feature/${feat}`,
      method: 'GET',
    },
  ]);
};

const getFeatureFlags = feats => {
  return multiRequest([
    {
      url: `customer/feature-flags/features/${feats}`,
      method: 'GET',
    },
  ]);
};
const FeatureFlagsService = {
  getFeatureFlag,
  getFeatureFlags,
};

export default FeatureFlagsService;
